export default __webpack_public_path__ + "static/media/Junior.2ac087e9.svg";